import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const HeroSection = styled.section`
  background: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.6)), url('/images/julian-ebert-zSflp4Mq_l0-unsplash.jpg');
  background-size: cover;
  background-position: center;
  height: 100vh;
  max-height: 800px;
  min-height: 600px;
  display: flex;
  align-items: center;
  position: relative;
  
  &:before {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 100px;
    background: linear-gradient(to top, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0));
    z-index: 1;
  }
  
  .hero-content {
    color: #fff;
    position: relative;
    z-index: 2;
    padding: 50px 0;
    
    h1 {
      font-size: 3.5rem;
      font-weight: 800;
      margin-bottom: 20px;
      text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
      
      span {
        color: #ff9800;
      }
      
      @media (max-width: 768px) {
        font-size: 2.5rem;
      }
    }
    
    p {
      font-size: 1.25rem;
      margin-bottom: 30px;
      max-width: 700px;
      text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
      
      @media (max-width: 768px) {
        font-size: 1.1rem;
      }
    }
    
    .hero-btns {
      display: flex;
      gap: 15px;
      
      @media (max-width: 576px) {
        flex-direction: column;
      }
    }
    
    .btn {
      padding: 12px 30px;
      font-weight: 600;
      font-size: 1.1rem;
      border-radius: 50px;
      transition: all 0.3s ease;
      
      &:hover, &:focus {
        transform: translateY(-3px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
      }
    }
    
    .btn-primary {
      background-color: #ff9800;
      border-color: #ff9800;
      
      &:hover, &:focus {
        background-color: #f57c00;
        border-color: #f57c00;
      }
    }
    
    .btn-outline-light {
      &:hover, &:focus {
        background-color: #2e7d32;
        border-color: #2e7d32;
      }
    }
  }
  
  .trust-badges {
    margin-top: 50px;
    display: flex;
    align-items: center;
    gap: 30px;
    
    @media (max-width: 768px) {
      flex-wrap: wrap;
      gap: 20px;
    }
    
    .badge-item {
      display: flex;
      align-items: center;
      
      .badge-icon {
        background-color: rgba(255, 255, 255, 0.2);
        border-radius: 50%;
        width: 50px;
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 15px;
        
        svg {
          color: #ff9800;
          font-size: 1.5rem;
        }
      }
      
      .badge-text {
        h5 {
          font-size: 1rem;
          font-weight: 700;
          margin-bottom: 0;
        }
        
        p {
          font-size: 0.875rem;
          margin-bottom: 0;
          opacity: 0.8;
        }
      }
    }
  }
`;

const Hero = () => {
  return (
    <HeroSection>
      <Container>
        <Row>
          <Col lg={10} xl={8}>
            <div className="hero-content">
              <h1>Sell Your Land Fast For <span>Cash</span></h1>
              <p>
                We buy land directly from owners throughout the USA. No commissions, no fees, no stress. 
                Get a fair cash offer and close on your timeline.
              </p>
              <div className="hero-btns">
                <Button as={Link} to="/get-offer" className="btn-primary">
                  Get Your Cash Offer
                </Button>
                <Button as={Link} to="/how-it-works" variant="outline-light">
                  How It Works
                </Button>
              </div>
              {/* Trust badges removed as requested */}
            </div>
          </Col>
        </Row>
      </Container>
    </HeroSection>
  );
};

export default Hero;
